import styled from 'styled-components'

export const Container = styled.div`
  margin-top: -${props => props.theme.spacing.sp24};
  div {
    justify-content: center;
    font-family: ${props => props.theme.texts.bodySRegular.fontFamily};
    font-size: ${props => props.theme.texts.bodySRegular.fontSize};
    color: ${props => props.theme.colors.warning.onSurface};
  }

  svg {
    height: ${props => props.theme.size.XXS};
    width: ${props => props.theme.size.XXS};
    fill: ${props => props.theme.colors.warning.onSurface};
    color: ${props => props.theme.colors.warning.onSurface};
  }
`
